import { compose } from 'redux';
import { change as changeFormValue, formValueSelector, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { fillPaymentForm } from '../../../common/debug/utils';
import { PAYMENT } from '../../../constants/formNamesConstants';
import PaymentPage from '../entry-page/components/PaymentPage';
import { scrollToElement } from '../../../utils/scrollToElement';
import { reduxFields, TAX_ID } from '../constants/formFields';
import { withValidationProvider } from '../higher-order-components/WithValidationProvider';
import {
  getCardSchemaId,
  getCardTypeId,
  getCommercialCardTypeId,
} from '../payment-methods/card/utils/formSelectors';
import {
  getSelectedPaymentMethodId,
  getSelectedPaymentMethod,
} from '../entry-page/utils/paymentMethod';
import { paymentMethodCodes, paymentMethodTypes } from '../constants/paymentMethods';

const {
  PRICE_CHANGE_DISPLAYED,
  SELECTED_PAYMENT_METHOD,
  SELECTED_PAYMENT_METHOD_SUB_SECTION,
  METHOD_SUBSECTION_CODE,
} = reduxFields;

const scrollToFirstError = () => {
  setTimeout(() => {
    const inputFieldWithErrorSelector = '.error,input[aria-invalid="true"]';

    const firstError = document.querySelector(inputFieldWithErrorSelector);
    if (firstError) {
      scrollToElement(firstError, 80);
    }
  }, 1);
};

const onSubmitFail = (
  _errors,
  _dispatch,
  _submitError,
  { sendTrackEvent, isSnowplowTrackingEnabled },
) => {
  const isPaymentPage = window.location.pathname.includes('/payment');

  if (isSnowplowTrackingEnabled && isPaymentPage) {
    sendTrackEvent({
      category: 'Payment',
      action: 'Error',
      label: 'Validation Error',
    });
  }
  scrollToFirstError();
};

const connectFormToState = reduxForm({
  form: PAYMENT,
  touchOnChange: true,
  touchOnBlur: true,
  onSubmitFail,
});

const mapStateToProps = (state, { paymentMethods }) => {
  const selectedCardId = getCardTypeId(PAYMENT)(state) || null;
  const selectedCommercialCardId = getCommercialCardTypeId(PAYMENT)(state) || null;
  const selectedMainPaymentMethod = formValueSelector(PAYMENT)(state, SELECTED_PAYMENT_METHOD);
  const selectedPaymentMethodCode = selectedMainPaymentMethod?.code;
  const selectedPaymentMethodType = selectedMainPaymentMethod?.type;
  const selectedSubsectionCode =
    selectedMainPaymentMethod?.[SELECTED_PAYMENT_METHOD_SUB_SECTION]?.[METHOD_SUBSECTION_CODE];

  const selectedCardSchemaId =
    selectedPaymentMethodType === paymentMethodTypes.CARD &&
    selectedPaymentMethodCode === paymentMethodCodes.CARD
      ? getCardSchemaId(PAYMENT)(state)
      : undefined;

  const selectedPaymentMethod = getSelectedPaymentMethod(
    selectedPaymentMethodCode,
    selectedPaymentMethodType,
    undefined,
    selectedCommercialCardId,
    paymentMethods,
    selectedSubsectionCode,
  );

  const selectedPaymentMethodId = getSelectedPaymentMethodId(
    selectedPaymentMethodType,
    selectedCardSchemaId ? Number(selectedCardSchemaId) : selectedCardId,
    selectedMainPaymentMethod?.id ?? selectedPaymentMethod?.id,
    paymentMethods,
  );

  return {
    paymentMethods,
    selectedCommercialCardId,
    selectedMainPaymentMethod,
    selectedPaymentMethodCode,
    selectedPaymentMethodId,
    selectedPaymentMethodType,
    selectedSubsectionCode,
  };
};

const mapDispatchToProps = (dispatch) => ({
  populateTaxId: (taxId) => dispatch(changeFormValue(PAYMENT, TAX_ID, taxId)),
  fillForm: (change) => {
    fillPaymentForm(dispatch, change);
  },
  populatePriceChangeDisplayed: (price) => {
    dispatch(changeFormValue(PAYMENT, PRICE_CHANGE_DISPLAYED, price));
  },
});

export default compose(
  withValidationProvider,
  connect(mapStateToProps, mapDispatchToProps),
  connectFormToState,
)(PaymentPage);
